module.exports = __webpack_public_path__ + "media/application/images/external-services/faire-logo-7cc75835f45b67c221fa1b2641fb389b.svg";